import types from "../assets/constants/types";
import summary from "../assets/overview.svg"
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

const SurveysGridRow = (props) => {
    const navigate = useNavigate()
    const survey = props.survey;

    const handleRowClick = (ev) => {
        if(ev.target.id === `survey-grid-navigate-${survey.id}`) {
            if(survey.demo) {
                navigate(`/surveys/${survey.id}?overview=true&demo=true`)
            } else {
                navigate(`/surveys/${survey.id}?overview=true`)
            }
        } else {
            props.handleClick(survey)
        }
    }

    return (
        <div className="surveys-grid-row link" id={`survey-grid-${survey.id}`} onClick={handleRowClick}>
            <div className="surveys-grid-row-organisation-logo" style={{backgroundColor: '#' + survey.colour}} id={`survey-grid-${survey.id}`}/>
            <div className="surveys-grid-row-organisation-name" id={`survey-grid-${survey.id}`}>{survey.organisation_name}</div>
            <div className="surveys-grid-row-team-name" id={`survey-grid-${survey.id}`}>{survey.team_name}</div>
            <div className="surveys-grid-row-survey-type" id={`survey-grid-${survey.id}`}>{types.survey_types.find(x => x.id === survey.survey_type).name}</div>
            <div className="surveys-grid-row-survey-point" id={`survey-grid-${survey.id}`}>{types.point_types.find(x => x.id === survey.survey_point).name}</div>
            <div className="surveys-grid-row-survey-expiry" id={`survey-grid-${survey.id}`}>{survey.expiry_date === 9999999999
                ? "N/A"
                : new Date(survey.expiry_date * 1000).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                })}</div>
            <div className="surveys-grid-row-survey-co-coach" id={`survey-grid-${survey.id}`} title={
                survey.co_coach_firstname || survey.co_coach_lastname
                    ? `${survey.co_coach_firstname ?? ""} ${survey.co_coach_lastname ?? ""}`.trim()
                    : "N/A"}>
                {survey.co_coach_firstname || survey.co_coach_lastname
                ? `${survey.co_coach_firstname ?? ""} ${survey.co_coach_lastname ?? ""}`.trim()
                : "N/A"}
            </div>
            <div className="surveys-grid-row-survey-summary">
                <img src={summary} alt="summary icon" id={`survey-grid-navigate-${survey.id}`}/>
            </div>
        </div>
    )
}

export default SurveysGridRow;
